export default {
  FORGOT_PASSWORD: '/auth/forgot-password'
}
